module.exports = __webpack_public_path__ + "media/digital/Degitization-Testimonial-64b0bf57.png";